import React from 'react'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { OmnibusCommsUploadView } from '../components/views/omnibusCommsUploadView'
import { Page, PageHeader } from '../ui'

/**
 * Admin > Omnibus comms upload: load a comms-provider `conversations.csv`
 * export (the same format used for the original client communications
 * import) into the client comms tables and link the contacts to omnibus
 * clients. Sentinel admins only — the endpoint 403s everyone else and the
 * view bounces them home.
 */
function OmnibusCommsUpload() {
    return (
        <div className="omnibusCommsUpload">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Admin"
                        title="Omnibus comms upload"
                        intro="Upload a conversations.csv send-log export (emails and SMS) to record what has been sent to clients. Messages already stored are skipped, so overlapping exports are safe to upload. Preview first to see what would change."
                    />
                    <OmnibusCommsUploadView />
                </Page>
            </MainView>
        </div>
    )
}

export default OmnibusCommsUpload
